// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2ORp8","name":"ConsentHeader_name__MtErD","birthday":"ConsentHeader_birthday__2yyBd","skeleton":"ConsentHeader_skeleton__3o-RN"};